import { Entry } from '../Entry'

export function Entry20231219() {
  return (
    <Entry title="Dec 19 2023 - v3.5.9">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15606/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
